<template>
  <div
    class="app"
  >
    <router-view
      v-slot="{ Component }"
    >
      <transition
        name="fade-view"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { fireUtagView } from '@garmin/support-analytics';

export default {
  name: 'App',
  watch: {
    $route() {
      fireUtagView();
    },
  },
};
</script>
<style lang="scss">
  @import '@/styles/layout/index';
</style>
